







































import { Component, Prop, Vue } from "vue-property-decorator";
import { project } from "../../types";
declare var TweenMax: any;
declare var TimelineLite: any;
declare var Expo: any;

@Component
export default class Projects extends Vue {
	@Prop() private projs!: project[];

	$openCard?: HTMLElement;
	sequence: any;
	$panel1?: HTMLElement = document.getElementById("about") as HTMLElement;
	$panel2?: HTMLElement = document.getElementById("contact") as HTMLElement;
	$allCards: any = document.querySelectorAll("card");
	$herotext?: HTMLElement = document.querySelector(
		".hero__text"
	) as HTMLElement;

	mounted() {}

	open(cardId: string, event: MouseEvent) {
		var $card: HTMLElement = document.getElementById(cardId) as HTMLElement;

		// Prevent when card already open and user click on image.
		if (this.$openCard === $card) {
			let $target: HTMLElement = event.target as HTMLElement;
			if($target.classList.contains('card__link')){
				return;
			} else if ($target.classList.contains("card__btn-close")) {
				this.closeCard($card);
				event.preventDefault();
				return;
			}
			event.preventDefault();
			return;
		}

		event.preventDefault();
		this.$openCard = $card;

		// 1. Slide down label
		// 2. add large mask + shrink mask
		// 3. Float card to final position
		// 4. expand to show entire
		// 5. show content below vp

		// Create timeline for the whole sequence.
		this.sequence = new TimelineLite({ paused: true });
		this.sequence.add(this.slideContentDown($card), 0);
		this.sequence.add(this.clipImageIn($card), 0);
		this.sequence.add(this.floatContainer($card), "-=.2");
		this.sequence.add(this.clipImageOut($card), "-=.2");
		this.sequence.add(this.slideContentUp($card), "-=.5");
		$card.classList.add("card--open");
		this.sequence.play();
	}

	// 1. Slide down label
	slideContentDown($card: HTMLElement) {
		var $content = $card.querySelector(".card__content");
		var tween = TweenMax.to($content, 0.5, {
			y: window.innerHeight,
			ease: Expo.easeInOut
		});
		return tween;
	}

	// 2. add large mask + shrink mask
	clipImageIn($card: HTMLElement) {
		var $clip = $card.querySelector(".clip");
		var tween = TweenMax.to($clip, 0.4, {
			attr: {
				r: 60
			},
			ease: Expo.easeInOut
		});
		return tween;
	}

	// 3. Float card to final position
	floatContainer($card: HTMLElement) {
		document.body.classList.add("body--hidden");
		var $container = $card.querySelector(".card__container") as HTMLElement;

		var TL = new TimelineLite(),
			rect = $container.getBoundingClientRect(),
			windowW = window.innerWidth,
			track = {
				width: 0,
				x: rect.left + rect.width / 2,
				y: rect.top + rect.height / 2
			};

		TL.set($container, {
			width: rect.width,
			height: rect.height,
			x: rect.left,
			y: rect.top,
			position: "fixed",
			overflow: "hidden"
		});

		TL.to([$container, track], 0.6, {
			width: 800, // responsive!
			height: "100%",
			x: windowW / 2,
			y: 0,
			xPercent: -50,
			ease: Expo.easeInOut,
			clearProps: "all",
			className: "-=card__container--closed"
		});

		return TL;
	}

	// 4. expand to show entire img
	clipImageOut($card: HTMLElement) {
		var $clip = $card.querySelector(".clip") as HTMLElement;
		var radius = $clip.getAttribute("r");
		var tween = this.clipImageIn($card);
		tween.vars.attr.r = radius;
		return tween;
	}

	// 5. show content below vp
	slideContentUp($card: HTMLElement) {
		var $content = $card.querySelector(".card__content");
		var tween = TweenMax.to($content, 0.6, {
			y: 0,
			clearProps: "all",
			ease: Expo.easeInOut
		});
		return tween;
	}

	// close: clearProps and reverse timeline
	closeCard($card: HTMLElement) {
		var $container = $card.querySelector(".card__container") as HTMLElement;
		var $content = $card.querySelector(".card__content");

		$container.style.cssText = "overflow: hidden;";
		this.sequence.eventCallback("onReverseComplete", () => {
			TweenMax.set(
				[
					$container,
					$content,
					this.$allCards,
					this.$panel1,
					this.$panel2,
					this.$herotext
				],
				{
					clearProps: "all"
				}
			);
			document.body.classList.remove("body--hidden");
			$card.classList.remove("card--open");
		});
		this.sequence.reverse();
		this.$openCard = undefined;
	}
}
